module.exports = __webpack_public_path__ + "img/image-quick-a5beac0c.png";